Ext.define('SA.view.legend.Legend', {
    alias: 'widget.map-legend',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-legend x-unselectable sa-legend-dark',
    editMode: false,
    hidden: true,
    mapCenter: {},
    mapCenterUnit: 'auto',
    overCls: 'sa-legend-over',
    positionOffsets: [-2, 1],
    showBusinesses: true,
    showColorRanges: true,
    showMapCenter: true,
    showMapTitle: true,
    saAnim: {position: false, sizeBySides: true},

    items: [
        {
            xtype: 'legend-header',
            saAnim: true
        }, {
            xtype: 'legend-map-center',
            saAnim: true
        }, {
            xtype: 'legend-category-options',
            saAnim: true
        }, {
            cls: 'sa-legend-separator',
            saAnim: true,
            separator: true,
            xtype: 'component'
        }, {
            xtype: 'legend-businesses',
            saAnim: true
        }, {
            cls: 'sa-legend-separator',
            saAnim: true,
            separator: true,
            xtype: 'component'
        }, {
            xtype: 'component',
            cls: 'sa-legend-release',
            itemId: 'censusRelease',
            saAnim: true,
            tpl: 'Geographic Year: {year}'
        }, {
            xtype: 'component',
            cls: 'sa-legend-map-title',
            itemId: 'title',
            saAnim: true,
            tpl: '{name:htmlEncode}, {year} by {geographicUnit}'
        }, {
            xtype: 'legend-outline-options',
            saAnim: true
        }, {
            xtype: 'component',
            cls: 'sa-legend-edit-control-label',
            html: 'Category Ranges',
            itemId: 'categoryRangesLabel',
            margin: '5 18 3',
            saAnim: true
        }, {
            xtype: 'legend-color-ranges',
            saAnim: true
        }, {
            xtype: 'sa-button',
            itemId: 'editButton',
            saAnim: true,
            text: 'Edit',
            ui: 'legend',

            handler() {
                var legendView = this.up('map-legend'),
                    map = legendView.map,
                    legend = map.getLegendBreaks();

                if (legendView.isDrag) {
                    return;
                }

                legendView.addCls('sa-legend-active');

                legendView.editMode = true;

                if (legend && legend.colorScheme === 'custom') {
                    legendView.down('legend-category-options').addCustomColors(legend.colors);
                }

                legendView.refresh();
            }
        }, {
            xtype: 'sa-button',
            cls: 'sa-legend-button',
            itemId: 'editorButton',
            margin: '7 0 0',
            saAnim: true,
            text: 'Done',
            ui: 'legend',

            handler() {
                var legend = this.up('map-legend');

                if (legend.isDrag) {
                    return;
                }

                legend.removeCls('sa-legend-active');

                legend.editMode = false;

                legend.refresh();
            }
        }, {
            xtype: 'component',
            itemId: 'insufficientVariationMsg',
            margin: '0 5 5',
            saAnim: true,
            tpl: '<div class="sa-legend-warning-msg">{message}</div>'
        }
    ],

    afterRender() {
        this.callParent();

        this.animation = new SA.Animation(this);

        this.mon(this.el.down('.sa-legend-header-button'), 'click', this.onHeaderButtonClick, this);

        this.el.on({
            mousedown: this.onLegendMouseDown,
            touchstart: this.onLegendMouseDown,

            scope: this
        });
    },

    getGeographicUnits() {
        var countryCode = this.map.getCountry(),
            censusRelease = this.map.getCensusRelease() || SA.model.Country.get(countryCode).getLatestCensusRelease(),
            supportedUnits = SA.data.GeographicUnits.forCountryAndCensusRelease(countryCode, censusRelease),
            discoverableUnits = this.map.getProject().getDiscoverableGeographicUnits();

        return supportedUnits.filter(unit => discoverableUnits.includes(unit.id));
    },

    getMapEl() {
        return this.up().getEl();
    },

    loadMapCenter() {
        var oldCenter = this.lastCenter,
            oldYear = this.lastYear,
            map = this.map,
            center = map.getExtent().getCenter(),
            year = map.getGeographicRelease(),
            query;

        if (!year) {
            return;
        }

        if (!center.equals(oldCenter) || oldYear !== year) {
            let units = this.getGeographicUnits().map(({id}) => id);

            this.lastCenter = center;
            this.lastYear = year;

            query = SA.data.Query.from({
                type: 'locations',

                fields: ['name', 'geographicUnit'],
                limit: units.length,

                where: [
                    'and',
                    ['in', 'geographicUnit', ...units],
                    ['=', 'geographicRelease', year],
                    ['contains', center.getX(), center.getY()]
                ]
            });

            query.addSuccess(this.onMapCenterLoad, this);

            query.run();
        }
    },

    onHeaderButtonClick(ev) {
        var button = ev.getTarget('.sa-legend-header-button'),
            groupId = this.id + '-theme-group',
            menu = this.lastHeaderMenu;

        if (this.isDrag) {
            return;
        }

        if (menu && menu.wasRecentlyVisible()) {
            return;
        }

        Ext.fly(button).addCls('sa-legend-header-button-active');

        this.addCls('sa-legend-active');

        menu = this.lastHeaderMenu = Ext.widget({
            xtype: 'arrow-menu',

            alignment: 'left/right-down',
            positionEl: button,
            saAnim: true,
            target: this,
            track: true,

            plugins: [{
                ptype: 'sa-animation',
                add: false,
                hide: false,
                show: false,
                size: false
            }],

            items: [
                {
                    checked: this.showMapCenter,
                    text: SA.localize('Show Map Center'),
                    xtype: 'menucheckitem',

                    checkHandler: (item, checked) => {
                        this.showMapCenter = checked;
                        this.refresh();
                    }
                }, {
                    checked: this.showMapTitle,
                    text: 'Show Title',
                    xtype: 'menucheckitem',

                    checkHandler: (item, checked) => {
                        this.showMapTitle = checked;
                        this.refresh();
                    }
                }, {
                    checked: this.showBusinesses,
                    text: 'Show Businesses',
                    xtype: 'menucheckitem',

                    checkHandler: (item, checked) => {
                        this.showBusinesses = checked;
                        this.refresh();
                    }
                }, {
                    checked: this.showColorRanges,
                    text: SA.localize('Show Color Ranges'),
                    xtype: 'menucheckitem',

                    checkHandler: (item, checked) => {
                        this.showColorRanges = checked;
                        this.refresh();
                    }
                }, {
                    xtype:'menuseparator'
                }, {
                    xtype: 'menucheckitem',
                    checked: this.hasCls('sa-legend-dark'),
                    group: groupId,
                    text: 'Dark Theme',

                    checkHandler: (item, checked) => {
                        this.ifCls(checked, 'sa-legend-dark');
                    }
                }, {
                    xtype: 'menucheckitem',
                    checked: this.hasCls('sa-legend-light'),
                    group: groupId,
                    text: 'Light Theme',

                    checkHandler: (item, checked) => {
                        this.ifCls(checked, 'sa-legend-light');
                    }
                }
            ],

            listeners: {
                destroy: () => {
                    this.removeCls('sa-legend-active');

                    Ext.fly(button).removeCls('sa-legend-header-button-active');

                    Reflect.deleteProperty(this, 'lastHeaderMenu');
                }
            }
        });
    },

    onLegendMouseDown(ev) {
        this.isDrag = false;

        if (ev.getTarget('.sa-legend-header-button') || ev.getTarget('.sa-button') || ev.getTarget('input')) {
            return;
        }

        Ext.destroy(this.dragMoveData);

        var me = this,
            xy1 = ev.getXY(),
            el = this.el,
            doc = Ext.getDoc(),
            mapEl = this.getMapEl(),
            mapX = mapEl.getX(),
            mapY = mapEl.getY(),
            legendX = el.getX() - mapX,
            legendY = el.getY() - mapY,
            mapHeight = mapEl.getHeight(),
            mapWidth = mapEl.getWidth(),
            offsets = this.positionOffsets,
            holdTimer = setTimeout(() => {
                el.addCls('sa-legend-drag');

                this.isDrag = true;
            }, 750),
            mouseup = () => Ext.destroy(dragMoveData),
            dragMoveData = this.dragMoveData = {};

        if (ev.type === 'touchstart') {
            doc.on('touchcancel', mouseup);
            doc.on('touchend', mouseup);
            doc.on('touchmove', mousemove);

            dragMoveData.touchId = ev.browserEvent.changedTouches[0].identifier;

            dragMoveData.destroy = function() {
                doc.un('touchcancel', mouseup);
                doc.un('touchend', mouseup);
                doc.un('touchmove', mousemove);

                clean();
            };
        }
        else {
            doc.on('mousemove', mousemove);
            doc.on('mouseup', mouseup);

            dragMoveData.destroy = function() {
                doc.un('mousemove', mousemove);
                doc.un('mouseup', mouseup);

                clean();
            };
        }

        function mousemove(ev) {
            me.animation.cancel();

            var xy2 = ev.getXY(),
                dx = xy2[0] - xy1[0],
                dy = xy2[1] - xy1[1],
                constrain = Ext.Number.constrain,
                touchId = dragMoveData.touchId,
                maxX, maxY, x, y, propX, propY;

            if (touchId && ev.browserEvent.changedTouches[0].identifier !== touchId) {
                Ext.destroy(dragMoveData);

                return;
            }

            ev.preventDefault();

            if (!me.isDrag) {
                if (dx * dx + dy * dy > 4) {
                    el.addCls('sa-legend-drag');

                    me.isDrag = true;

                    clearTimeout(holdTimer);
                }
            }

            if (me.isDrag) {
                maxX = Math.max(0, mapWidth - el.getWidth());
                maxY = Math.max(0, mapHeight - el.getHeight());
                x = constrain(legendX + dx, 0, maxX);
                y = constrain(legendY + dy, 0, maxY);

                el.setStyle({
                    left: x + 'px',
                    top: y + 'px'
                });

                propX = x / maxX;
                propY = y / maxY;

                offsets[0] = toOffset(propX, x, maxX);
                offsets[1] = toOffset(propY, y, maxY);
            }

            function toOffset(prop, abs, max) {
                if (prop < 0.2) {
                    return abs;
                }
                else if (prop > 0.8) {
                    return abs - max - 1;
                }

                return prop;
            }
        }

        function clean() {
            clearTimeout(holdTimer);

            el.removeCls('sa-legend-drag');

            me.dragMoveData = null;

            me.animation.run();
        }
    },

    onMapCenterLoad(results) {
        var mapCenter = this.mapCenter = {};

        results.forEach(locationSeries => {
            mapCenter[locationSeries.geographicUnit] = locationSeries.name;
        });

        this.refresh();
    },

    refresh() {
        this.animation.cancel();

        var map = this.map,
            attributeId = map.getAttribute(),
            attribute = SA.data.AttributesCache.get(attributeId),
            businessSearch = SA.data.BusinessSearches.get(map.getBusinessSearch()),
            mapCenterUnit = this.mapCenterUnit,
            unitsSynced = map.syncGeographicUnits(),
            hasAttributeWithUnitsAtCurrentScale = map.hasAttributeWithUnitsAtCurrentScale(),
            hasSufficientDataVariation = !map.hasLackOfDataVariation(),
            unitSyncPending = !unitsSynced && !map.attributeLacksUnitsAtCurrentScale(),
            header = this.down('legend-header'),
            centerLabel = this.down('legend-map-center'),
            title = this.down('#title'),
            censusReleaseEl = this.down('#censusRelease'),
            rangesCt = this.down('legend-color-ranges'),
            businesses = this.down('legend-businesses'),
            editButton = this.down('#editButton'),
            editorButton = this.down('#editorButton'),
            categoryOptions = this.down('legend-category-options'),
            outlineOptions = this.down('legend-outline-options'),
            categoryRangesLabel = this.down('#categoryRangesLabel'),
            insufficientVariationMsg = this.down('#insufficientVariationMsg'),
            ct = this.up(),
            editMode = hasAttributeWithUnitsAtCurrentScale && hasSufficientDataVariation && this.editMode,
            cmChange = false,
            norChange = false,
            exChange = false,
            censusRelease = map.getCensusRelease(),
            showRelease = map.isReleaseVisible(),
            geographicUnit, legendBreaks, legendSettings, insufficientData, insufficientMsg;

        if (!map.isLegendVisible() || unitSyncPending) {
            this.hide();

            Ext.destroyMembers(this, 'resizeListener');

            return;
        }

        if (!ct) {
            setTimeout(this.refresh.bind(this), 50);

            return;
        }

        if (ct.isHidden()) {
            ct.on('show', this.refresh, this, {buffer: 10, single: true});

            return;
        }

        if (!this.resizeListener) {
            this.resizeListener = this.mon(ct, 'resize', this.updatePosition, this, {destroyable: true});
        }

        geographicUnit = SA.data.GeographicUnits.get(map.getGeographicUnit());

        legendBreaks = map.getLegendBreaks();
        legendSettings = map.getLegendSettings();

        Ext.suspendLayouts();

        this.ifCls(editMode, 'sa-legend-edit-mode');
        header.update(editMode ? 'Edit Legend' : 'Legend');

        this.ifCls(showRelease, 'sa-legend-historical');
        censusReleaseEl.update({year: censusRelease});

        if ((this.showColorRanges || editMode) && hasAttributeWithUnitsAtCurrentScale && hasSufficientDataVariation) {
            if (legendSettings && legendBreaks && attribute) {
                rangesCt.refresh();

                rangesCt.show();
            }
            else if (editMode) {
                rangesCt.setLoading('Calculating ranges…');
            }
        }
        else {
            rangesCt.hide();
        }

        if (!this.getGeographicUnits().some(unit => unit.id === mapCenterUnit)) {
            mapCenterUnit = this.mapCenterUnit = 'auto';
        }

        if (mapCenterUnit === 'auto') {
            let defaultCenterUnit = SA.data.GeographicUnits.getSmallestUnitForCountryAndScale(map.getCountry(), map.getScale());

            mapCenterUnit = (geographicUnit || defaultCenterUnit).id;
        }

        if (this.showMapCenter && !editMode) {
            centerLabel.update({
                label: SA.localize('Map Center'),
                name: this.mapCenter[mapCenterUnit]  || 'No Location Found'
            });

            centerLabel.show();
        }
        else {
            centerLabel.hide();
        }

        if (this.showMapTitle && geographicUnit && attribute && !editMode) {
            title.update({
                geographicUnit: geographicUnit.name,
                name: attribute.name,
                year: attribute.year
            });

            title.show();
        }
        else {
            title.hide();
        }

        if (this.showBusinesses && businessSearch && !editMode) {
            businesses.update({
                name: businessSearch.name
            });

            businesses.show();
        }
        else {
            businesses.hide();
        }

        editButton.setDisabled(!legendBreaks || !legendSettings);
        editButton.setVisible(hasAttributeWithUnitsAtCurrentScale && hasSufficientDataVariation && !editMode);
        editorButton.setVisible(editMode);
        categoryOptions.setVisible(editMode);
        categoryRangesLabel.setVisible(editMode);
        outlineOptions.setVisible(editMode);

        if (editMode && attribute) {
            if (legendSettings && legendBreaks) {
                insufficientData = {};

                cmChange = legendSettings.classificationMethod !== legendBreaks.classificationMethod;
                norChange = legendSettings.numberOfRanges !== legendBreaks.numberOfRanges;
                exChange = !legendSettings.extent !== !legendBreaks.extent;

                if (cmChange || norChange || exChange) {
                    insufficientData.targetMethod = legendSettings.classificationMethod;
                    insufficientData.numberOfRanges = legendSettings.numberOfRanges;
                }

                if (cmChange || exChange) {
                    insufficientData.actualMethod = legendBreaks.classificationMethod;
                }

                if (exChange && !cmChange) {
                    insufficientData.targetMethod = 'Local ' + insufficientData.targetMethod;
                    insufficientData.actualMethod = 'National ' + insufficientData.actualMethod;
                }

                if (rangesCt.isRangesInvalid()) {
                    insufficientData.rangesInvalid = true;
                }

                editorButton.setDisabled(insufficientData.rangesInvalid);

                if (SA.Object.isEmpty(insufficientData)) {
                    insufficientVariationMsg.hide();
                }
                else {
                    if (insufficientData.rangesInvalid) {
                        insufficientMsg = 'The current custom ranges are not valid and have not been saved. The map is displaying the previous configuration.';
                    }
                    else {
                        insufficientMsg = insufficientData.numberOfRanges + ' ' + insufficientData.targetMethod + ' could not be generated due to insufficient variation within the data.';

                        if (insufficientData.targetMethod === 'custom') {
                            insufficientMsg = 'A suitable set of custom ranges have not been specified.';
                        }

                        if (insufficientData.actualMethod) {
                            insufficientMsg += ' The values shown are ' + insufficientData.actualMethod + '.';
                        }
                    }

                    insufficientVariationMsg.update({message: insufficientMsg});

                    insufficientVariationMsg.show();
                }
            }
        }
        else {
            insufficientVariationMsg.hide();
        }

        this.query('> [separator]').forEach(separator => {
            separator.show();
        });

        this.query('> :not({isHidden()})').forEach((item, index, all) => {
            if (item.separator) {
                var previous = all[index - 1];

                item.setVisible(previous && !previous.separator);
            }
        });

        categoryOptions.refresh();
        outlineOptions.refresh();

        Ext.resumeLayouts(true);

        this.show();

        this.updatePosition();
        this.lastHeaderMenu?.syncPosition();

        this.animation.run();
    },

    updatePosition() {
        var offsets, el, x, y, myHeight, myWidth, ctHeight, ctWidth;

        this.animation.cancel();

        if (!this.isHidden()) {
            offsets = this.positionOffsets;
            el = this.getMapEl();

            x = offsets[0];
            y = offsets[1];

            myHeight = this.getHeight();
            myWidth = this.getWidth();

            ctHeight = el.getHeight();
            ctWidth = el.getWidth();

            if (x < 0) {
                x += ctWidth - myWidth + 1;
            }
            else if (x < 1) {
                x *= ctWidth - myWidth;
            }

            if (y < 0) {
                y += ctHeight - myHeight + 1;
            }
            else if (y < 1) {
                y *= ctHeight - myHeight;
            }

            this.el.setStyle({
                left: x + 'px',
                top: y + 'px'
            });
        }
    }
});